import { connect } from 'react-redux';

import FopCorner from '../../components/fopPartials/FopCorner';

export default connect(state => ({
  basketItems: state.basket.items,
  user: state.user,
}))(FopCorner);
